import React from 'react'
import { formatMoney } from '../utils/formatMoney'

export function OpsStatsCards({ stats, navigateToOperations, onPageChange }) {
  return (
    <div className="dashboard-section" data-tour="dashboard-ops-stats" style={{ marginBottom: '20px' }}>
      <div className="dashboard-section-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
        Операционная активность
      </div>
      <div className="dashboard-stats-grid">
        <div className="dashboard-card clickable-card card-issued" onClick={() => navigateToOperations('issued')}>
          <div className="card-header">
            <span className="card-title">Выданные товары</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{stats.issued} <span style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-secondary)' }}>шт.</span></div>
          <div className="card-footer">Перейти к операциям →</div>
        </div>

        <div className="dashboard-card clickable-card card-accepted" onClick={() => navigateToOperations('acceptance')}>
          <div className="card-header">
            <span className="card-title">Принятые товары</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/>
                <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{stats.accepted} <span style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-secondary)' }}>шт.</span></div>
          <div className="card-footer" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Вовремя: <strong>{stats.acceptedOnTime}</strong> | С опозданием: <strong>{stats.acceptedLate}</strong>
          </div>
        </div>

        <div className="dashboard-card clickable-card card-returns" onClick={() => navigateToOperations('returns')}>
          <div className="card-header">
            <span className="card-title">Возвратные коробки</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
            </span>
          </div>
          <div className="card-value">{stats.returnsBoxes} <span style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-secondary)' }}>короб.</span></div>
          <div className="card-footer" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Товаров: <strong>{(stats.returnsOnTime || 0) + (stats.returnsLate || 0)}</strong>
            {(stats.returnsLate || 0) > 0 && <span style={{ color: 'var(--danger)', marginLeft: '6px' }}>Просрочено: <strong>{stats.returnsLate}</strong></span>}
          </div>
        </div>

        <div className="dashboard-card clickable-card card-deductions" onClick={() => onPageChange('deductions')}>
          <div className="card-header">
            <span className="card-title">Удержания</span>
            <span className="card-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="6" cy="6" r="3"/>
                <circle cx="6" cy="18" r="3"/>
                <line x1="20" y1="4" x2="8.12" y2="15.88"/>
                <line x1="14.47" y1="14.48" x2="20" y2="20"/>
                <line x1="8.12" y1="8.12" x2="12" y2="12"/>
              </svg>
            </span>
          </div>
          <div className="card-value">-{formatMoney(stats.deductionsSum)}</div>
          <div className="card-footer">Сумма всех вычетов за период</div>
        </div>
      </div>
    </div>
  )
}
